import { take } from "lodash-es";

import BPostService from "@/services/bpost.service";

export const autocomplete =
    (onTimeout: () => void) => async (query: string) => {
        const { isTimeout, topSuggestions } =
            await BPostService.autocomplete(query);

        if (isTimeout) onTimeout();

        return take(topSuggestions, 5).map(({ address }) => address);
    };
